import { createSelector } from 'reselect';

import { Checklist } from 'types';

const getChecklist = (checklists: Checklist[], checklistId: string) => checklists.find(checklist => checklist.id === checklistId);
export const makeGetChecklist = () => createSelector(getChecklist, checklists => checklists);
